import React from "react";
import { Routes, Route } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Layout from "./components/layout/Layout";
import LoadingSpinner from "./components/common/LoadingSpinner";

// Lazy load pages for better performance
const Home = React.lazy(() => import("./pages/Home"));
const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));
const LelangList = React.lazy(() => import("./pages/LelangList"));
const LelangDetail = React.lazy(() => import("./pages/LelangDetail"));
const CreateLelang = React.lazy(() => import("./pages/CreateLelang"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Profile = React.lazy(() => import("./pages/Profile"));

function App() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="large" text="Memuat aplikasi..." />
      </div>
    );
  }

  return (
    <Layout>
      <React.Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/lelang" element={<LelangList />} />
          <Route path="/lelang/:id" element={<LelangDetail />} />
          <Route path="/lelang/create" element={<CreateLelang />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </React.Suspense>
    </Layout>
  );
}

export default App;
